<template>
  <div class="data-safety">
    <div class="introduce data-safety-box">
      <div class="flex align-center title">
        <h2>{{ info.language_list.data_safety.title }}</h2>
        <i
          class="iconfont icon-youjiantou"
          @click="handleConfirm"></i>
      </div>
      <p>
        {{ info.language_list.data_safety.describe }}
      </p>
    </div>
    <div class="data-safety-list">
      <ul>
        <li>
          <i class="iconfont icon-fenxiang"></i>
          <div>
            {{ info.language_list.data_safety.share }}
            <p>
              {{ info.language_list.data_safety.learn_more }}
              <!-- <span @click="handleConfirm">Learn more</span> about how
              developers declare sharing -->
            </p>
          </div>
        </li>
        <li>
          <i class="iconfont icon-yunshangchuan"></i>
          <div>
            {{ info.language_list.data_safety.data_type }}
            <p>{{ info.language_list.data_safety.location }}</p>
          </div>
        </li>
        <li>
          <i class="iconfont icon-suoding"></i>
          <div>{{ info.language_list.data_safety.data }}</div>
        </li>
        <li>
          <i class="iconfont icon-lajitong"></i>
          <div>{{ info.language_list.data_safety.deleted }}</div>
        </li>
      </ul>
    </div>
    <p
      @click="handleConfirm"
      :class="[
        'flex',
        'align-center',
        info.template_id === 2 || info.template_id === 5
          ? 'fl-start'
          : 'fl-end',
      ]">
      <span>{{ info.language_list.data_safety.details }}</span>
      <i class="iconfont icon-gengduo"></i>
    </p>
  </div>
</template>
<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';

const store = useStore();
const info = computed(() => store.state.appInfo);

const emit = defineEmits(['confirm']);

const handleConfirm = () => {
  emit('confirm');
};
</script>

<style lang="scss" scoped>
.data-safety {
  .data-safety-list {
    margin: 20px 0;
    border: rgb(218, 220, 224) 1px solid;
    border-radius: 8px;
    padding: 20px;

    li {
      display: flex;
      align-items: flex-start;
      i {
        margin-right: 5px;
      }
    }
    li + li {
      margin-top: 20px;
    }
    li img {
      margin-right: 20px;
    }
  }
  > p {
    margin-top: 20px;
    color: var(--main-color);
    font-size: 12px;
    span {
      padding-right: 5px;
    }
  }
}
</style>
